import { IPagedResultViewModel, Alert } from '../models';
import { IAgrConfiguration } from '../models/ConfigurationModel';
import { BaseService } from './BaseService';

/**
 * The service class to interact with the Alert.
 */
export class AlertService extends BaseService {
  constructor(config: IAgrConfiguration | undefined) {
    super(config, '/alert');
  }

  getAllPaged(filter: string): Promise<IPagedResultViewModel<Alert>> {
    return this.get('?' + filter);
  }

  getCount(filter: any): Promise<number> {
    return this.get('/count?' + filter);
  }

  getCSVSubscription(filter: string): Promise<string> {
    return this.get(`/csv?` + filter);
  }

  delete(subscriptionId: number): Promise<void> {
    return super.delete(`/${subscriptionId}`);
  }
}
